import { Directive, computed, input } from '@angular/core';
import { BrnAccordionTrigger } from '@spartan-ng/brain/accordion';
import { hlm } from '@spartan-ng/helm/utils';

import type { ClassValue } from 'clsx';

@Directive({
  selector: '[hlmAccordionTrigger]',
  standalone: true,
  host: {
    '[style.--tw-ring-offset-shadow]': '"0 0 #000"',
    '[class]': '_computedClass()',
  },
  hostDirectives: [BrnAccordionTrigger],
})
export class HlmAccordionTrigger {
  // eslint-disable-next-line @angular-eslint/no-input-rename
  public readonly userClass = input<ClassValue>('', { alias: 'class' });
  protected readonly _computedClass = computed(() =>
    hlm(
      'w-full focus-visible:outline-none text-sm focus-visible:ring-1 focus-visible:ring-ring focus-visible:ring-offset-2 flex flex-1 items-center justify-between py-4 px-0.5 font-medium underline-offset-4 hover:underline [&[data-state=open]>[hlmAccordionIcon]]:rotate-180 [&[data-state=open]>[hlmAccIcon]]:rotate-180',
      this.userClass(),
    ),
  );
}
